import React, { useState } from 'react';

import DialogModal from './DialogModal';

import Button from 'CommonComponents/Button';
import LoadingSpinner from 'CommonComponents/LoadingSpinner';

/** A destructive confirmation: what will be removed, a keep button and a delete button. */
export default function ConfirmDeleteModal({ id, isOpen, onClose, title, loading = false, children, keepLabel, deleteLabel, onConfirm }) {
    const [deleting, setDeleting] = useState(false);

    const confirm = async () => {
        setDeleting(true);

        try {
            await onConfirm();
        } finally {
            setDeleting(false);
        }
    };

    return (
        <DialogModal id={id} isOpen={isOpen} onClose={onClose} title={title} danger widthClass="tw-max-w-md">
            <div className="modal__form-container tw-flex tw-flex-col tw-gap-y-1.5 tw-text-sm tw-text-charcoal-75">
                {loading ? <LoadingSpinner size="sm" /> : children}
                <div className="modal__footer tw-justify-end tw-gap-x-1.5">
                    <Button variant="secondary" onClick={onClose} disabled={deleting}>
                        {keepLabel}
                    </Button>
                    <Button variant="danger" onClick={confirm} disabled={deleting || loading} loading={deleting}>
                        {deleteLabel}
                    </Button>
                </div>
            </div>
        </DialogModal>
    );
}
